import IngredientsManager from '../components/IngredientsManager';
import {
  getEffectiveCommercantId,
  isPlatformIngredientsReadOnly,
} from '../utils/assistanceSession';

const Ingredients = () => {
  const getCurrentUser = () => {
    try {
      const userData = localStorage.getItem('admin_user');
      if (userData) {
        return JSON.parse(userData);
      }
    } catch (error) {
      console.error('Erreur parsing user data:', error);
    }
    return null;
  };

  const currentUser = getCurrentUser();
  const userCommercantId = getEffectiveCommercantId(currentUser);
  // SA hors assistance = catalogue plateforme lecture seule ; en assistance = CRUD boutique.
  const platformReadOnly = isPlatformIngredientsReadOnly(currentUser);

  return (
    <IngredientsManager
      commercantId={userCommercantId}
      isSuperAdmin={platformReadOnly}
    />
  );
};

export default Ingredients;
